export const defaultDateOptions = {
    default: {
    // 12/31/2020
    },
};
